import version from '../schema/version';
export const STRIPE_CONTEXT_HEADER_FOR_V1 = 'X-Client-Only-Stripe-Context-For-V1-Queries';
const ACCOUNT_HEADER = 'Stripe-Account';
const AUTHORIZATION_HEADER = 'Authorization';
const CONTENT_TYPE_HEADER = 'Content-Type';
const LIVEMODE_HEADER = 'Stripe-Livemode';
const REQUESTED_WITH_HEADER = 'X-Requested-With';
const STRIPE_VERSION_HEADER = 'Stripe-Version';
function getLiveMode(value) {
    switch(value){
        case 'FORCE_LIVE':
            return 'true';
        case 'FORCE_TEST':
            return 'false';
        default:
            return null;
    }
}
export default function addContextHeaders(headers, v1Context) {
    const { accountId, apiKey, betaHeaders = undefined, compartmentId, liveMode } = v1Context;
    const liveModeValue = getLiveMode(liveMode);
    const stripeAccountValue = accountId || null;
    if (liveModeValue !== null && !headers.get(LIVEMODE_HEADER)) {
        headers.set(LIVEMODE_HEADER, liveModeValue);
    }
    if (stripeAccountValue !== null && !headers.get(ACCOUNT_HEADER)) {
        headers.set(ACCOUNT_HEADER, stripeAccountValue);
    }
    if (compartmentId && !headers.get(STRIPE_CONTEXT_HEADER_FOR_V1)) {
        headers.set(STRIPE_CONTEXT_HEADER_FOR_V1, compartmentId);
    }
    if (apiKey && !headers.get(AUTHORIZATION_HEADER)) {
        headers.set(AUTHORIZATION_HEADER, `Bearer ${apiKey}`);
    }
    if (!headers.get(REQUESTED_WITH_HEADER)) {
        headers.set(REQUESTED_WITH_HEADER, 'XMLHttpRequest');
    }
    if (!headers.get(CONTENT_TYPE_HEADER)) {
        headers.set(CONTENT_TYPE_HEADER, 'application/x-www-form-urlencoded');
    }
    // Beta headers: https://confluence.corp.stripe.com/display/DEVX/Beta+headers.
    const betaHeadersStr = betaHeaders ? `;${Object.entries(betaHeaders).map(([name, value])=>`${name}=${value}`).join(';')}` : '';
    if (!headers.get(STRIPE_VERSION_HEADER)) {
        headers.set(STRIPE_VERSION_HEADER, `${version}${betaHeadersStr}`);
    }
}

//# sourceMappingURL=addContextHeaders.js.map